module.exports = __webpack_public_path__ + "img/40ne.1b8c76aa.svg";